export const usrPermission = {
    home: {
        r: "home:read"
    },
    exhibitors: {
        c: "exhibitors:create",
        r: "exhibitors:read",
        u: "exhibitors:update",
        d: "exhibitors:delete",
    },
    guestSpeakers: {
        c: "guest-speakers:create",
        r: "guest-speakers:read",
        u: "guest-speakers:update",
        d: "guest-speakers:delete",
    },
    gallery: {
        c: "gallery:create",
        r: "gallery:read",
        u: "gallery:update",
        d: "gallery:delete",
    },
    event: {
        c: "event:create",
        r: "event:read",
        u: "event:update",
        d: "event:delete",
    },
    partners: {
        c: "partners:create",
        r: "partners:read",
        u: "partners:update",
        d: "partners:delete",
    },
    designer: {
        c: "designer:create",
        r: "designer:read",
        u: "designer:update",
        d: "designer:delete",
    },
    message: {
        // c: "contact-us:create",
        r: "message:read",
        u: "message:update",
        d: "message:delete",
    },
    siteInfo: {
        r: "site-info:read",
        u: "site-info:update",
        // d: "site-info:delete",
    }

}